module.exports = __webpack_public_path__ + "static/img/img_biaodan_pc.24f2544.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/appDownLoad/pc/img_biaodan_pc.png
// module id = h9J+
// module chunks = 1